__turbopack_context__.v({
  "arc": "WebsocketUpgrade-module__a48iOW__arc",
  "bullet": "WebsocketUpgrade-module__a48iOW__bullet",
  "codeBar": "WebsocketUpgrade-module__a48iOW__codeBar",
  "codeGlyph": "WebsocketUpgrade-module__a48iOW__codeGlyph",
  "ctaBtn": "WebsocketUpgrade-module__a48iOW__ctaBtn",
  "ctaWrap": "WebsocketUpgrade-module__a48iOW__ctaWrap",
  "db": "WebsocketUpgrade-module__a48iOW__db",
  "eyebrow": "WebsocketUpgrade-module__a48iOW__eyebrow",
  "grid": "WebsocketUpgrade-module__a48iOW__grid",
  "head": "WebsocketUpgrade-module__a48iOW__head",
  "idesc": "WebsocketUpgrade-module__a48iOW__idesc",
  "img": "WebsocketUpgrade-module__a48iOW__img",
  "imgWrap": "WebsocketUpgrade-module__a48iOW__imgWrap",
  "item": "WebsocketUpgrade-module__a48iOW__item",
  "ititle": "WebsocketUpgrade-module__a48iOW__ititle",
  "list": "WebsocketUpgrade-module__a48iOW__list",
  "mockCard": "WebsocketUpgrade-module__a48iOW__mockCard",
  "mockRow": "WebsocketUpgrade-module__a48iOW__mockRow",
  "section": "WebsocketUpgrade-module__a48iOW__section",
  "subtitle": "WebsocketUpgrade-module__a48iOW__subtitle",
  "title": "WebsocketUpgrade-module__a48iOW__title",
  "visual": "WebsocketUpgrade-module__a48iOW__visual",
  "visualCard": "WebsocketUpgrade-module__a48iOW__visualCard",
});
